export const autoDownloadFile = (res) => {
  if (res?.data) {
    const file = new Blob([res.data]);
    const filename = res.headers['content-disposition']?.split('filename=')?.[1];
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);
    link.download = decodeURIComponent(filename);
    link.click();
  }
};

// eslint-disable-next-line import/prefer-default-export
export const downloadOrViewPdfFile = (file, fileName, isView = false) => {
  const fileURL = URL.createObjectURL(file);
  if (isView) {
    window.open(fileURL, '_blank');
  } else {
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;

    link.click();
  }
};
